var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0705 20.3957L14.0801 20.403C14.9059 20.9803 15.9039 21.2585 16.9093 21.1918C17.9147 21.1251 18.8672 20.7174 19.6095 20.036L20.2543 19.4445C20.3972 19.3135 20.5128 19.1557 20.5947 18.98C20.6766 18.8043 20.723 18.6142 20.7313 18.4205C20.7397 18.2268 20.7098 18.0334 20.6434 17.8513C20.577 17.6692 20.4753 17.502 20.3442 17.3592L17.8494 14.6415C17.7185 14.4986 17.5606 14.3829 17.3849 14.301C17.2092 14.2192 17.0191 14.1727 16.8254 14.1644C16.6317 14.156 16.4383 14.1859 16.2562 14.2523C16.0741 14.3188 15.9069 14.4204 15.7641 14.5515C15.4757 14.8159 15.0941 14.955 14.7033 14.9381C14.3124 14.9213 13.9442 14.7498 13.6797 14.4616L9.69082 10.112C9.4264 9.82362 9.28732 9.44205 9.30419 9.05117C9.32105 8.66029 9.49247 8.29211 9.78074 8.0276V8.0276C9.92363 7.89661 10.0393 7.73876 10.1212 7.56305C10.203 7.38734 10.2495 7.19722 10.2578 7.00356C10.2662 6.8099 10.2363 6.61649 10.1699 6.43438C10.1034 6.25228 10.0018 6.08504 9.87071 5.94224L7.37689 3.22457C7.11238 2.93629 6.7442 2.76487 6.35332 2.74801C5.96244 2.73115 5.58087 2.87022 5.29251 3.13465L4.64672 3.72608C3.90412 4.40704 3.41605 5.32097 3.26317 6.31687C3.11029 7.31276 3.30174 8.33101 3.8059 9.20336L3.81137 9.21344C6.48508 13.5622 9.96765 17.3581 14.0705 20.3957V20.3957Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioCall);
export default __webpack_public_path__ + "static/media/audio-call.05d2b30368a803c649a9a2de8c84d20f.svg";
export { ForwardRef as ReactComponent };